import { Controller } from "@hotwired/stimulus"

/** Dismissible flash: optional auto-hide (success ~5s). Errors stay until dismissed. */
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 }
  }

  connect() {
    if (this.delayValue > 0) {
      this.timeoutId = window.setTimeout(() => this.dismiss(), this.delayValue)
    }
  }

  disconnect() {
    this.clearTimer()
  }

  clearTimer() {
    if (this.timeoutId != null) {
      window.clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  dismiss(event) {
    event?.preventDefault()
    this.clearTimer()
    this.element.style.transition = "opacity 0.2s ease"
    this.element.style.opacity = "0"
    window.setTimeout(() => this.element.remove(), 220)
  }
}
